import React, { useEffect, useState } from "react";
import { randoms } from "lib/utils";
import type { DevEvent } from "../eventsystem"
import { eventsystem } from "../eventsystem";
import { LogViewer } from ".";
import { TableViewer } from ".";
// import { ErrorViewer } from "./viewers/ErrorViewer";
// import { ImageViewer } from "./viewers/ImageViewer";
// import { DividerViewer } from "./viewers/DividerViewer";
// import { HeadlineViewer } from "./viewers/HeadlineViewer";

export default function EventViewer(){
  const [events, setEvents] = useState<Array<DevEvent & { id: number }>>([]);
  
  const generateId = () => randoms.string(12, "a#")

  useEffect(() => {
    const unsubscribe = eventsystem.subscribe((event: DevEvent) => {
      setEvents( (prev:any) => [...prev, { id: generateId(), ...event }]);
    });
  
    return () => {
      unsubscribe();
    };
  }, []);  

  return (
    <div className="space-y-4 p-4">
      {events.map((event) => {
        switch (event.type) {
          case "log":
            return <LogViewer key={event.payload.id} message={event.payload.message} />;
          // case "error":
          //   return <ErrorViewer key={event.payload.id} {...event.payload} />;
          // case "image":
          //   return <ImageViewer key={event.payload.id} {...event.payload} />;
          case "table":
            return <TableViewer key={event.payload.id} data={event.payload.data} />;
          // case "divider":
          //   return <DividerViewer key={event.payload.id} {...event.payload} />;
          // case "headline":
          //   return <HeadlineViewer key={event.payload.id} {...event.payload} />;
          case "clear":
            setEvents([]); // Wipe log if you want
            return null;
          default:
            return null;
        }
      })}
    </div>
  );
};
